import { getDataMapper, mapField } from "@/shared";

export const mapZadarmaCredsToServer = getDataMapper({
    zadarma_key: mapField("zadarmaKey"),
    zadarma_secret: mapField("zadarmaSecret"),
    zadarma_phone: mapField("zadarmaPhone"),
});
